import React from "react";
import { ArrowUpRight, Github, Linkedin, Twitter } from "lucide-react";
import { Input } from "./ui/input";

const FORM_ACTION = "https://formsubmit.co/support@vynfive.com";

const COLS = [
  // { title: "Services", links: ["Cloud Engineering", "DevOps & Platform", "Software Development", "AI & Machine Learning", "IT Staffing", "Digital Transformation"] },
  // { title: "Company", links: ["About", "Case Studies", "Careers", "Process", "Contact"] },
  // { title: "Resources", links: ["Blog", "Documentation", "Technologies", "FAQs", "Privacy"] },
];

export default function Footer() {
  const newsletterNext = `${window.location.origin}/?newsletter-thanks=1`;

  return (
    <footer data-testid="footer" className="relative border-t border-line overflow-hidden">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12 pt-20 pb-8"> 
       <div className="mt-6 flex gap-3">
              {[
                { Icon: Linkedin, href: "https://www.linkedin.com/company/vynfive/" },
                // { Icon: Twitter, href: "#" },
                // { Icon: Github, href: "#" },
              ].map((item, i) => (
                <a key={i} href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel={item.href.startsWith("http") ? "noreferrer" : undefined} className="grid place-items-center h-10 w-10 rounded-full glass hover:text-brand transition-colors">
                  <item.Icon size={16} />
                </a>
              ))}
            </div>
            <div className="mt-16 pt-8 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-textsub">
              <p>© {new Date().getFullYear()} VYNFIVE TECHLABS LLP. All rights reserved.</p>
              <p className="font-mono text-xs">Engineering the Future with Intelligent Technology</p>
            </div>
          </div>
      {/* <div className="max-w-[90rem] mx-auto px-6 lg:px-12 pt-20 pb-8">
        <a href="#contact" className="group block">
          <h3 className="font-heading font-bold tracking-tighter leading-none text-[15vw] lg:text-[11vw] text-gradient">
            {"Let's Talk"}
          </h3>
        </a>

        <div className="mt-16 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center h-9 w-9 rounded-lg bg-gradient-to-br from-brand to-secondary">
                <span className="font-heading font-bold text-[#05050A] text-lg">V</span>
              </span>
              <span className="font-heading text-lg font-bold">Vyn<span className="text-gradient">Five</span></span>
            </div>
            <p className="mt-5 text-textsub max-w-xs leading-relaxed">
              Engineering the future with intelligent technology — Cloud, DevOps, AI, Software & Talent.
            </p>
            <form action={FORM_ACTION} method="POST" className="mt-7 flex gap-2 max-w-sm" data-testid="newsletter-form">
              <input type="hidden" name="_subject" value="New newsletter signup from VynFive website" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_next" value={newsletterNext} />
              <Input name="email" data-testid="newsletter-email" type="email" placeholder="Your email" className="bg-transparent border-line h-11" required />
              <button data-testid="newsletter-submit" className="shrink-0 grid place-items-center h-11 w-11 rounded-md bg-brand text-[#05050A] hover:opacity-90">
                <ArrowUpRight size={18} />
              </button>
            </form>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Linkedin, href: "https://www.linkedin.com/company/vynfive/" },
                { Icon: Twitter, href: "#" },
                { Icon: Github, href: "#" },
              ].map((item, i) => (
                <a key={i} href={item.href} target={item.href.startsWith("http") ? "_blank" : undefined} rel={item.href.startsWith("http") ? "noreferrer" : undefined} className="grid place-items-center h-10 w-10 rounded-full glass hover:text-brand transition-colors">
                  <item.Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
            {COLS.map((c) => (
              <div key={c.title}>
                <p className="font-heading font-semibold mb-4">{c.title}</p>
                <ul className="space-y-3">
                  {c.links.map((l) => (
                    <li key={l}>
                      <a href="#services" className="text-sm text-textsub hover:text-brand transition-colors">{l}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-textsub">
          <p>© {new Date().getFullYear()} VYNFIVE TECHLABS LLP. All rights reserved.</p>
          <p className="font-mono text-xs">Engineering the Future with Intelligent Technology</p>
        </div>
      </div> */}
    </footer>
  );
}
